const styles = {
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '14px',
        lineHeight: '21px',
        textAlign: 'center',
        color: '#001533',
        paddingLeft: '16px',
        fontWeight: '600',
        textTransform: 'capitalize',
        cursor: 'pointer',
    },
    userTitle: {
        fontFamily: 'Silka_Medium',
        fontSize: '12px',
        lineHeight: '18px',
        textAlign: 'center',
        color: '#4D5C71',
        paddingLeft: '16px',
        fontWeight: '500',
        textTransform: 'capitalize',
    },
    rowLabel: {
        fontFamily: 'Silka_Regular',
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '400',
        color: '#4D5C71',
        paddingLeft: '10px',
        cursor: 'pointer',
    },
    email: {
        display: 'flex',
        alignItems: 'center',
    },
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '48px',
    },
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '598px',
        height: '48px',
        margin: '0px 24px',
    },
    countText: (size: number, radius: string, fontSize: number) => ({
        fontFamily: 'Silka_Bold',
        color: '#FFFFFF',
        backgroundColor: '#8697AB',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        height: size,
        width: size,
        borderRadius: radius,
        display: 'flex',
        fontWeight: 700,
        fontSize,
        textTransform: 'uppercase',
        marginLeft: '-7Px',
    }),
    confirm: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
    },
    cancel: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderWidth: '2px',
    },
    dateText: {
        fontFamily: 'Silka_Medium',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#4D5C71',
        fontWeight: '500',
    },
};
export default styles;
